<template>
	<footer class="footer">
		<p>
			<router-link class="" :to="{ name: 'settings', params: {}}">
				{{$t('common.settings')}}
			</router-link>
		</p>
		<p>
			<strong style="color: #3f51b5">
				Spazio utilizzato: {{ kb }}Mb ({{ perc }}%)
			</strong>
			-
			<span v-if="keyLastUpdated !== version" class="btn btn_aggiornamento" @click="update()">
				Aggiornamento disponibile. Cliccare per aggiornare
			</span>
			<span v-else>
				<span class="footer__copyright">&copy;</span> {{ year }}
				<a href="https://mwd.digital" target="_blank">MWD Digital</a>- Last Build: {{version}}
			</span>
		</p>
	</footer>
</template>
<script>
    import moment from 'moment';
    import localForage from 'localforage';

    export default {
        name: 'footer-component',
        data() {
            return {
                year: moment().format('YYYY'),
				kb: 0,
				perc: 0,
				version: '2022-06-09 065',
                keyLastUpdated: ''
            }
        },
        components: {},
		mounted() {
            this.init();
        },
        methods: {
            init() {
                let pSize = [];
				localForage.keys().then(keys => {
				    keys.map(k => {
				       pSize.push(localForage.getItem(k));
					});
                    Promise.all(pSize).then(res => {
                        let kb = JSON.stringify(res).length;
                        if(kb > 0) {
                            this.kb = (+(kb / 1024) / 1024).toFixed(2);
                            let r = (this.kb / 5) * 100;
                            this.perc = (r == 0) ? 1 : r.toFixed(0);
						}
                        return kb.toFixed(0);
                    });
				});

                this.keyLastUpdated = localStorage.getItem('key_updated');
                if(this.keyLastUpdated == null || this.keyLastUpdated != this.version) {
                    localStorage.setItem('key_updated', this.version);
                    this.$forceUpdate();
                }
            },
			update() {
                console.log(`Update to ${this.version}`);
                localStorage.setItem('key_updated', this.version);
                this.$forceUpdate();
                window.location.reload()
			}
        }
    }
</script>

<style lang="scss">
	.btn_aggiornamento {
		background: red;
		padding: 7px;
	}
</style>
